/**
 * @author Ric Gray
 */

export type ExternalCommuicationParentMessage =
{
	command:string,
	args:Array<any>
}

export enum Targets
{
	ALL_TARGETS = "*",
}

export type MessageCallback = (data : Array<any>)=>void;

export interface ExternalComm 
{
	setMessageCallback(message:string, callback:MessageCallback) : void;
	
	sendMsgToParent(msg:ExternalCommuicationParentMessage, target?:string):void;  
}